import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const Questions = MatxLoadable({
  loader: () => import("./Questions"),
});

const questionsRoutes = [
  {
    path: "/questions",
    component: Questions,
    auth: authRoles.admin,
  },
];

export default questionsRoutes;
